import { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export const useNavigateBackToPreviousRoute = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const previousRoute = new URLSearchParams(location.search).get(
    'previousRoute',
  );

  return useCallback(
    (fallbackRoute: string) => {
      navigate(previousRoute ?? fallbackRoute);
    },
    [navigate, previousRoute],
  );
};
